import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-184f1bf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail_info_wrap" }
const _hoisted_2 = { class: "detail_thumbnail" }
const _hoisted_3 = { class: "camera_desc" }
const _hoisted_4 = { class: "camera_name_wrap link_text" }
const _hoisted_5 = { class: "camera_info" }
const _hoisted_6 = { class: "flex_box" }
const _hoisted_7 = { class: "tags" }

import WhiteBox from '@/components/atoms/WhiteBox'
import Thumbnail from '@/components/atoms/Thumbnail'
import Icon from '@/components/atoms/Icon'
import EventIcon from '@/components/atoms/EventIcon'
import SimpleButton from '@/components/atoms/SimpleButton'
import Tag from '@/components/atoms/Tag'
import { Camera } from '@/@types/typescript-axios/api'
import { computed } from 'vue'

type PropsType = {
  cameraData: Camera
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraItemDetail',
  props: {
    cameraData: null
  },
  setup(__props: any) {

const props = __props as {
  cameraData: Camera
};



const linkParams = computed(() => ({
  name: 'detail',
  params: { code: props.cameraData.camera_code },
}))

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(WhiteBox), null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Thumbnail), {
              src: __props.cameraData.thumb_url,
              width: "100%"
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (__props.cameraData.camera_code)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _unref(linkParams)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.cameraData.camera_name), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", null, [
                _createVNode(_unref(Icon), {
                  type: "videocam",
                  color: "color-dark2",
                  size: "16"
                }),
                _createElementVNode("span", null, _toDisplayString(__props.cameraData.location_name), 1)
              ]),
              _createElementVNode("li", null, [
                _createVNode(_unref(Icon), {
                  type: "room",
                  color: "color-dark2",
                  size: "16"
                }),
                _createElementVNode("span", null, _toDisplayString(__props.cameraData.location_address), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cameraData.tags, (tag) => {
                  return (_openBlock(), _createBlock(_unref(Tag), {
                    text: tag.tag_name,
                    key: tag.tag_code,
                    class: "tag"
                  }, null, 8, ["text"]))
                }), 128)),
                (!__props.cameraData.use_nolive)
                  ? (_openBlock(), _createBlock(_unref(EventIcon), {
                      key: 0,
                      eventType: "liveCamera"
                    }))
                  : _createCommentVNode("", true),
                (__props.cameraData.use_parking_detect)
                  ? (_openBlock(), _createBlock(_unref(EventIcon), {
                      key: 1,
                      eventType: "illegalParking"
                    }))
                  : _createCommentVNode("", true),
                (__props.cameraData.use_motion)
                  ? (_openBlock(), _createBlock(_unref(EventIcon), {
                      key: 2,
                      eventType: "motion"
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            (__props.cameraData.camera_code)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: _unref(linkParams)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SimpleButton), {
                      icon: "play_circle_outline",
                      color: "color-primary",
                      size: "size-m",
                      "use-full-button": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('detail_camera_list_map.watch_video')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})